export default __webpack_public_path__ + "static/media/course2_R.9f693118.gif";